import styled from 'styled-components'
import { COLORS } from 'theme'

export const CollegeInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`

export const CollegeLogoContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const CollegeTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const CollegeNameText = styled.div`
  font-weight: 700;
  color: ${COLORS.PRIMARY};
`

export const CollegeCityText = styled.div`
  font-size: 14px;
  color: ${COLORS.TEXT_MEDIUM};
`
